import axios from 'axios';

import { type CustomerData } from '../../shared/types';

export async function fetchCustomerInformation(): Promise<CustomerData> {
    const { data } = await axios.get<CustomerData>('/api/customer');
    return data;
}
